import $ from 'jquery';

export function save_vote(t)
{
    var api_link = localStorage.getItem("api_url") + "save_vote";
    var parameters = {
        voter_name: t.state.voter_name,
        voter_email: t.state.voter_email,
        voter_phone: t.state.voter_phone,
        artist_name: t.state.artist_name,
        error_info:  "video_guid=" + t.state.videoData.video_guid
    };

    $.ajax({
        type: "POST",
        url: api_link,
        data: parameters,
        async: true,
        dataType: "json",
        success: function (response)
        { save_vote_success(t, response) },
        error: save_vote_error

    });
}
function save_vote_success(t, response)
{
    if (response)
    {
        t.onCloseVotePopup();
        t.showToast("Thanks for your vote", "success");
    }
}
function save_vote_error(response)
{

}